import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import type { QueryOptions } from "@/shared/lib/tanstack-query";
import {
  type UseQueryResult,
  useQueries,
  useQuery,
} from "@tanstack/react-query";
import { TrackManager } from "@x-mile/api-contract";
import type { GetCompaniesParams } from "../model";

export const useGetCompanies = (
  params: GetCompaniesParams,
  options?: QueryOptions<typeof TrackManager.useGetCompanies>,
): UseQueryResult<TrackManager.GetCompaniesQueryResult, undefined> => {
  const authHeaders = getAuthHeaders();
  const result = useQuery({
    ...options,
    queryKey: ["getCompanies", keysToSnakeCase(params)],
    queryFn: () =>
      TrackManager.getCompanies(
        // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
        keysToSnakeCase(params),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      ),
  });
  return result as UseQueryResult<
    TrackManager.GetCompaniesQueryResult,
    undefined
  >;
};

export const useMultipleGetCompanies = (
  paramsList: { [key: string | number]: GetCompaniesParams },
  options?: QueryOptions<typeof TrackManager.useGetCompanies> & {
    sortFunc?: (a: GetCompaniesParams, b: GetCompaniesParams) => number;
  },
): {
  [key: string | number]: UseQueryResult<
    TrackManager.GetCompaniesQueryResult,
    undefined
  >;
} => {
  const authHeaders = getAuthHeaders();
  const keys = Object.keys(paramsList);
  const sortedKeys = options?.sortFunc
    ? keys.sort((a, b) =>
        options?.sortFunc ? options.sortFunc(paramsList[a], paramsList[b]) : 0,
      )
    : keys;
  const result = useQueries({
    queries: sortedKeys.map((key) => {
      const params = paramsList[key];
      return {
        ...options,
        queryKey: ["getCompanies", keysToSnakeCase(params)],
        queryFn: () =>
          TrackManager.getCompanies(
            // バックエンド（rails）ではキーがスネークケースになっているため、クエリパラメータをスネークケースに変換する
            keysToSnakeCase(params),
            {
              headers: authHeaders.isOk() ? authHeaders.value : {},
            },
          ),
      };
    }),
  });
  const resultByKeys = Object.fromEntries(
    keys.map((key, i) => [key, result[i]]),
  );
  return resultByKeys as {
    [key: string | number]: UseQueryResult<
      TrackManager.GetCompaniesQueryResult,
      undefined
    >;
  };
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const useGetCompaniesMock = (
//   params: GetCompaniesParams,
//   options?: QueryOptions<typeof TrackManager.useGetCompanies>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getGetCompaniesMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useGetCompanies(params, {
//     enabled: workerStarted && options?.enabled,
//   });
// };

// export const useMultipleGetCompaniesMock = (
//   paramsList: { [key: string | number]: GetCompaniesParams },
//   options?: QueryOptions<typeof TrackManager.useGetCompanies>,
// ) => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await TrackManager.startMockServerWoker(
//         TrackManager.getGetCompaniesMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return useMultipleGetCompanies(paramsList, {
//     enabled: workerStarted && options?.enabled,
//   });
// };
